export default {
  s1: `Möchten Sie den Johanniter Notrufdienst selbst nutzen oder wird dieser von einer anderen Person (z.B. einer/einem Angehörigen) in Anspruch genommen?`,
  s2: `Geben Sie hier bitte die PLZ des Ortes ein, in dem der Notrufdienst genutzt werden soll.`,
  s3: `Damit ggf. etwaige Zuschüsse für den Notrufdienst berücksichtigt werden können, <br> erfassen Sie hier bitte, ob bei Ihnen oder der Person, die den Notrufdienst nutzen möchte, <br> ein Pflegegrad vorliegt oder dieser bereits beantragt wurde?\n`,
  s4: `Für eine optimale Angebotsfindung, wählen Sie bitte aus, wo der Notrufdienst hauptsächlich genutzt werden soll.`,
  s5Col1: `
    <ul>
      <li>Persönliche Gerätevorstellung und Einweisung durch einen Johanniter-Mitarbeiter</li>
      <li>Bereitstellung und Wartung des Notrufgerätes und des nach IP67 wasserdichten Handsenders (als Armband oder Kette)</li>
      <li>Hinterlegung der im Stammdatenblatt genannten Daten in der Johanniter-Notrufzentrale\n</li>
      <li>Anschluss an die 24 Stunden mit Fachpersonal besetzte Johanniter-Notrufzentrale\n</li>
      <li>Entgegennahme von Notrufen und Einleitung von Hilfemaßnahmen\n</li>
      <li>Benachrichtigung der vorher bestimmten Kontaktperson oder Betreuungsperson oder gegebenenfalls des Rettungsdienstes\n</li>
      <li>Hilfe bei der Beantragung zur Kostenübernahme nach SGB XI bei der Pflegekasse\n</li>
      <li>Regelmäßige Überprüfung des Notrufgerätes inkl. Handsender\n</li>
    </ul>`,
  s5Col2: `
    <ul>
      <li>Sichere Hinterlegung der Haus- & Wohnungsschlüssel bei den Johannitern\n</li>
      <li>Sicherstellung eines 24 Stunden Einsatzdienstes zur Wohnungsöffnung\n</li>
      <li>Alle Hilfeleistungen im Rahmen der Ersten Hilfe kostenfrei z. B. Hilfe nach Stürzen\n</li>
      <li>Bei Bedarf: Koordination weiterer Hilfemaßnahmen durch den Rettungs- oder Pflegedienst\n</li>
    </ul>`,
  s5Col3: `
    <ul>
      <li>Sicherstellung eines 24 Stunden Einsatzdienstes zur Wohnungsöffnung\n</li>
      <li>Alle Hilfeleistungen im Rahmen der Ersten Hilfe kostenfrei z. B. Hilfe nach Stürzen\n</li>
      <li>Bei Bedarf: Koordination weiterer Hilfemaßnahmen durch den Rettungs- oder Pflegedienst\n</li>
    </ul>`,
  s5Col4: `
    <ul>
      <li>Die Tagestaste des Hausnotrufgerätes kann auf Ihren Wunsch hin aktiviert werden. Diese können Sie in einem 24-Stunden-Intervall drücken.\n</li>
      <li>Das Hausnotrufgerät speichert automatisch die Uhrzeit der letzten Betätigung der Tagestaste und erwartet spätestens nach Ablauf des Intervalls das Betätigen der Tagestaste.
      <br> Vergessen Sie die erneute Aktivierung, erinnert Sie das Gerät durch einen Signalton an den Druck. Sollte auch danach keine Betätigung erfolgen, <br>
      wird automatisch ein Alarm in die Johanniter-Notrufzentrale gesendet.\n</li>
      <li>Die Johanniter vergewissern sich durch telefonische Kontaktaufnahme, ob bei Ihnen ein Notfall vorliegt. <br>Falls Sie sich nicht melden, gehen die Johanniter von einer Notsituation aus; die Bereitschaft macht sich sofort auf den Weg zu Ihnen.\n</li>
    </ul>`,
  s5Col5: `
    <ul>
      <li>Damit im Notfall wichtige Informationen schnell zur Hand sind, gibt es die SOS-Notfalldose. <br>In dieser Dose wird ein Blatt mit den wichtigsten Informationen hinterlegt. Im Notfall stehen diese Daten dem Helfer zur Verfügung.\n</li>
      <li>Die Dose wird in der Innentür des Kühlschranks gut sichtbar aufbewahrt. <br>Durch einen Aufkleber an der Wohnungs-/ Hauseingangstür (innen) und einem zweiten an der Kühlschranktür (außen) weiß der Helfer sofort, dass eine SOS-Dose vorhanden ist.\n</li>
    </ul>`,
  s5Col6: `
    <ul>
      <li>Die Broschüre enthält umfangreiche Empfehlungen zu wohnraumverbessernden Maßnahmen in den eigenen vier Wänden\n</li>
    </ul>`,
  s5Col7: `
   <ul>
    <li>Der „wöchentliche persönliche Anruf“ ist eine Komponente der Leistung Premium  im Hausnotruf.\n</li>
    <li>Die Johanniter rufen Sie wöchentlich im gewünschten Zeitraum an und erkundigen sich nach Ihrem Wohlbefinden.\n</li>
    <li>Die Johanniter sind Gesprächspartner und geben neben Freunden, Bekannten und Angehörigen weitere Sicherheit.\n</li>
   </ul>
   `,
  s5Col8: `
  <ul>
    <li>Wählen Sie aus einer Vielzahl von Zubehör, welches mit dem Hausnotrufgerät kombiniert<br> werden kann. Z.B. einem Rauchwarnmelder für die Wohnung oder einem Zugtaster für das Badezimmer. \n</li>
    <li>Über diese und weitere Lösungen beraten die Johanniter Sie gern in einem persönlichen Gespräch vor Ort.\n</li>
  </ul>`
};
